export default [
    {
        path: '/categories',
        name: 'categories',
        component: () => import('../pages/KurccCategoriesPage'),
        meta: {
            auth: true
        }
    }
]
